module.exports = __webpack_public_path__ + "img/balkongelaender_2.e2b96f80.jpg";